import { render } from "./pharmacybreadcrumb.vue?vue&type=template&id=28c6560f"
import script from "./pharmacybreadcrumb.vue?vue&type=script&lang=js"
export * from "./pharmacybreadcrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__